module.exports = __webpack_public_path__ + "img/symbol-fraction-right.98d04bd0.png";